export enum EnrollTransactionTypeEnum {
    Unknown = 0,
    OpenPlan = 1,
    NewHire = 2,
    LifeEvent = 3,
    OpenEnrollment = 4,
    BeneficiaryChange = 5,
    ChangeInEmploymentStatus = 6,
    ReturnFromLeave = 7,
    PerpetualEnrollment = 8,
    DependentAudit = 9,
    LateEntrantOpenEnrollment = 10,
    EnrollmentMessage = 11,
    Acquisition = 12,
    NetworkChange = 13,
}
